module.exports = __webpack_public_path__ + "img/Image 1.eeed9269.png";